module.exports = "<label data-material=\"none\" class=\"js-jurisdiction use-settings-link top clearfix\">\r\n        <input type=\"checkbox\">\r\n        <span>Use Current Jurisdiction Settings</span>\r\n</label>\r\n<span class=\"open-settings\">\r\n        <i class=\"fa fa-cog\"></i> Open Settings\r\n</span>\r\n<hr>\r\n\r\n<ul class=\"children-region\"></ul>\r\n<div class=\"disabled-shield\">Filtering by jurisdiction is not possible when there is an explicit jurisdiction in the search box</div>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/jurisdiction-filter-panel.html
// module id = 415
// module chunks = 1